import { HeartIcon } from '@langchain/untitled-ui-icons';

import { useParams } from 'react-router-dom';

import { IconButton } from '@/design-system';
import { useLikeRepoMutation, useRepo } from '@/hooks/useSwr';

const LikeButton = () => {
  const { owner, repo } = useParams();
  const { trigger: likeRepo } = useLikeRepoMutation(owner, repo!);
  const { data: repoObj, mutate } = useRepo(owner, repo!);

  if (!repoObj) return null;
  const onFavorite = async (e) => {
    e.preventDefault();
    await likeRepo({ json: { like: !repoObj?.repo?.liked_by_auth_user } });
    mutate();
  };
  const liked = repoObj?.repo?.liked_by_auth_user;
  return (
    <IconButton
      size="md"
      variant={'normal'}
      color={'secondary'}
      onClick={onFavorite}
      icon={HeartIcon}
      label={liked ? 'Liked' : 'Like'}
      iconClassName={liked ? '[&_path]:fill-red-500 text-red-500' : ''}
    />
  );
};

export default LikeButton;
